import React, { useEffect } from "react";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import "./tools.css";

import one from "../../assets/aiimages/tool/AWS AI & Google Cloud AI.png";
import two from "../../assets/aiimages/tool/Google Colab.png";
import three from "../../assets/aiimages/tool/Hugging Face Transformers.png";
import four from "../../assets/aiimages/tool/OpenCV.png";
import five from "../../assets/aiimages/tool/Power BI.png";
import six from "../../assets/aiimages/tool/Tableau.png";
import seven from "../../assets/aiimages/tool/jupyter.png";
import eight from "../../assets/aiimages/tool/numpy.png";
import nine from "../../assets/aiimages/tool/pandas.png";
import ten from "../../assets/aiimages/tool/pyspark.png";
import elven from "../../assets/aiimages/tool/python.png";
import twele from "../../assets/aiimages/tool/scikitlearn.png";
import twele1 from "../../assets/aiimages/tool/seaborn.png";

import twele2 from "../../assets/aiimages/tool/streamlit.png";
import twele3 from "../../assets/aiimages/tool/tensorflow.png";
// import twele from "../../assets/aiimages/tool/scikitlearn.png";



const clients = [
  { src: one, alt: "Apache JMeter" },
  { src: two, alt: "Appium" },
  { src: three, alt: "Appium JPG" },
  { src: four, alt: "Cucumber" },
  { src: five, alt: "Java" },
  { src: six, alt: "Jenkins" },
  { src: seven, alt: "JUnit" },
  { src: eight, alt: "LoadRunner" },
  { src: nine, alt: "Postman" },
  { src: ten, alt: "Selenium" },
  { src: elven, alt: "SoapUI" },
  { src: twele, alt: "TestNG" },
  { src: twele1, alt: "TestNG" },
  { src: twele2, alt: "TestNG" },
  { src: twele3, alt: "TestNG" },

];

function Tools() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <>
      <section style={{ marginTop: "50px" }}>
        <div className="headlines-for-all">
          <h4     data-aos="fade-up" >
            <span>Tools </span> Covered
          </h4>
          <p     data-aos="fade-up">
      Gain hands-on experience with the most in-demand Artificial Intelligence tools, models, and frameworks used to build intelligent applications.
          </p>
        </div>
      </section>

      <section className="our-clients-section">
        <div className="our-clients-container">
          <motion.div
            className="our-clients-track"
            animate={{ x: ["0%", "-100%"] }}
            transition={{
              ease: "linear",
              duration: 100,
              repeat: Infinity,
            }}
          >
            {[...clients, ...clients].map((client, i) => (
              <div
                className="client-item"
                key={i}
                data-aos="fade-up"
                data-aos-delay={i * 150} // DELAY ONE-BY-ONE
              >
                <img src={client.src} alt={client.alt} />
              </div>
            ))}
          </motion.div>
        </div>
      </section>
    </>
  );
}

export default Tools;
